import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { shape, string } from 'prop-types';
import { useToasts } from '@magento/peregrine';
import Toast from './toast';
import { useStyle } from '../../classify';
import defaultClasses from './toastContainer.module.css';
/**
 * A container for toast notifications.
 *
 * This component must be a child, nested or otherwise, of a
 * ToastContextProvider component.
 *
 * @typedef ToastContainer
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays toast notification data.
 */

var ToastContainer = function ToastContainer(props) {
  var classes = useStyle(defaultClasses, props.classes);

  var _useToasts = useToasts(),
      _useToasts2 = _slicedToArray(_useToasts, 1),
      toasts = _useToasts2[0].toasts; // Given a map of toasts each with a property "timestamp", sort and display
  // based on the timestamp.


  var sortByTimestamp = function sortByTimestamp(_ref, _ref2) {
    var _ref3 = _slicedToArray(_ref, 2),
        toastA = _ref3[1];

    var _ref4 = _slicedToArray(_ref2, 2),
        toastB = _ref4[1];

    return toastA.timestamp - toastB.timestamp;
  };

  var toastElements = Array.from(toasts).sort(sortByTimestamp).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        id = _ref6[0],
        toast = _ref6[1];

    var key = toast.isDuplicate ? Math.random() : id;
    return React.createElement(Toast, _extends({
      key: key
    }, toast));
  });
  return React.createElement("div", {
    id: "toast-root",
    className: classes.root
  }, toastElements);
};
/**
 * Props for {@link ToastContainer}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the
 *   ToastContainer and its Toast components
 * @property {String} classes.root CSS classes for the root container
 */


ToastContainer.propTypes = {
  classes: shape({
    root: string
  })
};
export default ToastContainer;